module.exports = __webpack_public_path__ + "media/audios/kid/lesson_2/audio_tpc2-4d5658c4e4721ff8f8b333b091cff97d.m4a";